module.exports = "/_next/static/images/d044e503d40f1f40cdab6eb98818809c-msi-xs.png";